import React from 'react';

export const EventFeedSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col h-full">
      {/* Comment box skeleton */}
      <div className="border-b border-gray-200 bg-white p-4">
        <div className="rounded-lg border border-gray-200 overflow-hidden">
          <div className="h-16 bg-gray-100 animate-pulse" />
          <div className="flex justify-between items-center px-3 py-2 bg-gray-50 border-t border-gray-100">
            <div className="h-4 w-4 bg-gray-100 rounded animate-pulse" />
            <div className="h-6 w-20 bg-gray-100 rounded animate-pulse" />
          </div>
        </div>
      </div>

      {/* Events list skeleton */}
      <div className="flex-1 overflow-y-auto bg-gray-50 p-4">
        <ul className="space-y-6" aria-label="Loading activity">
          {[...Array(5)].map((_, index) => (
            <li key={index} className="relative flex gap-x-4">
              {/* Timeline */}
              <div
                className="absolute top-0 left-0 flex w-6 justify-center -bottom-6"
                aria-hidden="true"
              >
                <div className="w-px bg-gray-200" />
              </div>

              {/* Icon */}
              <div className="relative flex h-6 w-6 flex-none items-center justify-center">
                <div className="h-6 w-6 rounded-full bg-gray-100 animate-pulse" />
              </div>

              {/* Content */}
              <div className="flex-auto min-w-0">
                <div className="h-4 bg-gray-100 rounded w-3/4 animate-pulse" />
                {index % 3 === 0 && (
                  <div className="mt-2 rounded-md p-3 ring-1 ring-gray-200 bg-white shadow-sm">
                    <div className="h-3 bg-gray-100 rounded w-full animate-pulse" />
                    <div className="h-3 bg-gray-100 rounded w-2/3 animate-pulse mt-2" />
                  </div>
                )}
              </div>

              {/* Time */}
              <div className="h-3 w-16 bg-gray-100 rounded animate-pulse flex-none py-0.5" />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
